
import moment from 'moment';
import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
// import ConnectionsHeader from '@/components/ConnectionsHeader.vue';
import DataTableHeader from '@/components/DataTableHeader.vue';
import ConnectionIter from '@/components/ConnectionIter.vue';
import ConnectionMUP1RequestDate from '@/components/connections/ConnectionMUP1RequestDate.vue';
import ConnectionProgress from '@/components/connections/ConnectionProgress.vue';
import ConnectionPracticeSendingDate from '@/components/ConnectionPracticeSendingDate.vue';
import ConnectionEndOfWorksDate from '@/components/ConnectionEndOfWorksDate.vue';
import ConnectionRDESendingDate from '@/components/ConnectionRDESendingDate.vue';
import OperationCustomer from '@/components/OperationCustomer.vue';
import OperationProvince from '@/components/OperationProvince.vue';
import OperationSupply from '@/components/OperationSupply.vue';
import OperationLead from '@/components/OperationLead.vue';
import OperationTags from '@/components/OperationTags.vue';
import ConnectionPracticeNumber from '@/components/ConnectionPracticeNumber.vue';
import ConnectionAssignments from '@/components/ConnectionAssignments.vue';
import ConnectionIterConfirmationDate from '@/components/ConnectionIterConfirmationDate.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import CancelledConnections from '@/components/CancelledConnections.vue';
import ConnectionStatus from '@/components/connections/ConnectionStatus.vue';
import ConnectionEneaPractice from '@/components/connections/ConnectionEneaPractice.vue';
import ConnectionDogane from '@/components/connections/ConnectionDogane.vue';
import ConnectionInstallationDate from '@/components/connections/ConnectionInstallationDate.vue';
import ConnectionPlan from '@/components/connections/ConnectionPlan.vue';
import ConnectionAuth from '@/components/connections/ConnectionAuth.vue';
import MultiBoolSelect from '@/components/MultiBoolSelect.vue';
import AssignmentFilterToggle from '@/components/AssignmentFilterToggle.vue';
import TimeoutButton from '@/components/TimeoutButton.vue';
import ConnectionDocsSentToPartner from '@/components/ConnectionDocsSentToPartner.vue';
import SaveFilterPresetMenu from '@/components/SaveFilterPresetMenu.vue';
import LoadFilterPresetMenu from '@/components/LoadFilterPresetMenu.vue';
import {
  Connection, ConnectionsList, DataTableHeaderOptions, OperationInfo, PermissionCode, User,
  ConfirmDialogOptions, ConnectionsFilters, LogicType, Category, Tag, PracticeAssigneesStatus,
  DocsSentToPartnerFilter,
} from '@/types';
import { operationInfoFromConnection } from '@/helpers';
import normalizeDocsSentToPartner from '@/helpers/normalizers';
import { getProvince } from '@/lib/italy';

moment.locale('it');

@Component({
  components: {
    Loading,
    DataTableHeader,
    AssignmentFilterToggle,
    // ConnectionsHeader,
    ConnectionIter,
    ConnectionMUP1RequestDate,
    ConnectionProgress,
    ConnectionPracticeSendingDate,
    ConnectionEndOfWorksDate,
    ConnectionRDESendingDate,
    OperationCustomer,
    OperationProvince,
    OperationSupply,
    OperationLead,
    OperationTags,
    ConnectionPracticeNumber,
    ConnectionAssignments,
    ConnectionIterConfirmationDate,
    ConfirmDialog,
    CancelledConnections,
    ConnectionStatus,
    ConnectionEneaPractice,
    ConnectionDogane,
    ConnectionInstallationDate,
    ConnectionPlan,
    ConnectionAuth,
    MultiBoolSelect,
    TimeoutButton,
    ConnectionDocsSentToPartner,
    SaveFilterPresetMenu,
    LoadFilterPresetMenu,
  },
})
export default class Connections extends Vue {
  firstTimeUpdating = true
  delayedUpdating: boolean | null = null

  headers: DataTableHeaderOptions[] = []

  filters: ConnectionsFilters = {}

  options = {} as {
    sortBy?: string[];
    sortDesc?: boolean[] | string[];
  }

  // FIXME: da spostare nelle definizioni di tipo
  iterItems = [
    {
      text: 'Non impostato',
      value: null,
    },
    {
      text: 'Ordinario',
      value: 'o',
    },
    {
      text: 'Semplificato',
      value: 's',
    },
    {
      text: 'Superbonus 110% - Ordinario',
      value: 'bo',
    },
    {
      text: 'Superbonus 110% - Semplificato',
      value: 'bs',
    },
    {
      text: 'Superbonus 110%',
      value: 'b',
    },
    {
      text: 'Pre Check Connessione',
      value: 'ps',
    },
    {
      text: 'Non applicabile',
      value: 'n',
    },
  ];

  previousSearch = ''

  applyFiltersTimeout = 0
  applyFiltersDisabled = true
  applyFiltersCount = 0

  // true: sono disponibili altri risultati da recuperare
  // false: sono stati recuperati tutti i risultati
  more = true

  tableElements: HTMLCollectionOf<Element> | null = null
  tableElement: Element | null = null

  headerElements: HTMLCollectionOf<Element> | null = null
  headerElement: HTMLElement | null = null

  contentElements: HTMLCollectionOf<Element> | null = null
  contentElement: HTMLElement | null = null

  cancelConnectionDialog = false
  loadingConnection: number | null = null
  hasHorizontalScroll = false

  cancelOptions: ConfirmDialogOptions = {
    title: 'Conferma archiviazione pratica di connessione',
    text: 'Questa azione archiverà la pratica di connessione.',
    question: 'Sei sicuro di voler procedere?',
    yesText: 'Sì, procedi',
    noText: 'Non archiviare',
    inputLabel: 'Motivazione',
    inputType: 'textarea',
    inputRequired: true,
    inputPlaceholder: 'Inserisci la motivazione dell\'archiviazione',
  }

  get connections(): ConnectionsList {
    return this.$store.getters.connectionsList;
  }

  get orderedConnections() {
    // TODO: Applicare eventuali ordinamenti
    return this.connections;
  }

  get updating() {
    return this.$store.getters.areConnectionsUpdating;
  }

  // La Connection selezionata memorizzata tramite Vuex
  get selectedConnection(): Connection | null {
    return this.$store.getters.currentConnection;
  }

  get currentFilters(): ConnectionsFilters { return this.$store.getters.currentConnectionsFilters; }

  get connectionsCount(): number {
    return this.$store.getters.currentConnectionsCount;
  }

  get practiceAssigneeUsers(): User[] {
    const userItems = this.$store.getters.users
      .filter((u: User) => {
        const userGroups = u.groups.map((g) => g.id);
        return userGroups.includes(19);
      });

    // prependo il valore per filtrare le connessioni senza assegnatario
    userItems.unshift({ name: 'Non impostato', id: null });

    return userItems;
  }

  get assignmentDateFieldNames(): string[] {
    const types = this.$store.getters.getAssignmentTypes;
    return types
      .filter((t: any) => this.hasPermission(t.permissionShow))
      .map((t: any) => `${t.id}AssignedDate`);
  }

  get assignmentDateFieldLabels(): string[] {
    const types = this.$store.getters.getAssignmentTypes;
    return types
      .filter((t: any) => this.hasPermission(t.permissionShow))
      .map((t: any) => `Data ${t.label.toLowerCase()}`);
  }

  get categories(): Category[] {
    return this.$store.getters.categories;
  }

  get visibleCategories() {
    return Array.isArray(this.categories)
      ? this.categories.filter((c) => !c.hidden && c.isActive)
      : [];
  }

  get tags(): Tag[] {
    return this.$store.getters.tags;
  }

  get visibleTags() {
    return Array.isArray(this.tags)
      ? this.tags.filter((t) => !t.hidden && t.isActive)
      : [];
  }

  get provinces() {
    return getProvince()
      .map((p) => ({ name: p.text, id: p.value }));
  }

  @Watch('updating')
  onUpdatingChange(val: boolean, oldVal: boolean) {
    if (!val && oldVal) {
      setTimeout(() => {
        this.delayedUpdating = false;
        this.firstTimeUpdating = false;
      }, 0);
    } else {
      this.delayedUpdating = true;
    }
  }

  @Watch('tableElements')
  onTableElements(val: HTMLCollectionOf<Element> | null) {
    console.log(`${this.constructor.name}: onTableElements()`); // eslint-disable-line no-console

    if (val !== null) {
      // eslint-disable-next-line prefer-destructuring
      this.tableElement = val[0];
    }
  }

  @Watch('tableElement')
  onTableElement(val: Element | null) {
    console.log(`${this.constructor.name}: onTableElement()`); // eslint-disable-line no-console

    if (val !== null) {
      // tableElement è già il .v-data-table__wrapper
      const wrapper = val as HTMLElement;

      // Aggiungi un unico listener per gestire sia scroll verticale che orizzontale
      wrapper.addEventListener('scroll', this.onTableScroll);

      // Controlla lo stato iniziale
      this.$nextTick(() => {
        this.onHorizontalScroll();
      });
    }
  }

  // Funzione wrapper che gestisce sia lo scroll verticale che orizzontale
  onTableScroll() {
    this.onScroll();
    this.onHorizontalScroll();
  }

  @Watch('headerElements')
  onHeaderElements(val: HTMLCollectionOf<HTMLElement> | null) {
    console.log(`${this.constructor.name}: onHeaderElements()`); // eslint-disable-line no-console

    if (val !== null) {
      // eslint-disable-next-line prefer-destructuring
      this.headerElement = val[0];
    }
  }

  @Watch('headerElement')
  onHeaderElement(val: HTMLElement | null) {
    console.log(`${this.constructor.name}: onHeaderElement()`); // eslint-disable-line no-console

    if (val !== null) {
      new ResizeObserver(this.onHeaderResize).observe(val);
    }
  }

  @Watch('contentElements')
  onContentElements(val: HTMLCollectionOf<HTMLElement> | null) {
    console.log(`${this.constructor.name}: onContentElements()`); // eslint-disable-line no-console

    if (val !== null) {
      // eslint-disable-next-line prefer-destructuring
      this.contentElement = val[0];
    }
  }

  get user(): User { return this.$store.getters.currentUser; }
  get userPermissions(): PermissionCode[] { return this.$store.getters.currentUserPermissions; }
  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  mounted() {
    console.log(`${this.constructor.name}: mounted()`); // eslint-disable-line no-console

    // Aggiorna la data/ora dell'ultima attività dell'utente corrente
    this.$store.dispatch('updateLastActivity');

    this.$nextTick(() => {
      // Recupera un riferimento alla tabella nel DOM
      this.tableElements = document.getElementsByClassName('v-data-table__wrapper');

      // Recupera un riferimento al contenitore dei filtri nel DOM
      this.headerElements = document.getElementsByClassName('view-connections-header');

      // Recupera un riferimento al contenitore dei filtri nel DOM
      this.contentElements = document.getElementsByClassName('view-connections-content');
    });
  }

  async created() {
    console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console

    // Inizializza le intestazioni delle colonne della tabella
    this.initHeaders();

    // Inizializza i filtri
    this.initFilters();

    // Inizializza i preset dei filtri
    await this.$store.dispatch('initConnectionsFilterPresets');
  }

  async beforeDestroy() {
    console.log(`${this.constructor.name}: beforeDestroy() - Deseleziona la Connection`); // eslint-disable-line no-console

    this.$store.dispatch('unselectConnection');
  }

  destroyed() {
    console.log(`${this.constructor.name}: destroyed()`); // eslint-disable-line no-console

    if (this.tableElement) {
      // tableElement è già il .v-data-table__wrapper
      const wrapper = this.tableElement as HTMLElement;
      wrapper.removeEventListener('scroll', this.onTableScroll);
    }

    this.$store.dispatch('clearConnectionsList');
  }

  initHeaders() {
    console.log(`${this.constructor.name}: initHeaders()`); // eslint-disable-line no-console

    this.headers.push({
      text: 'Commessa',
      value: 'id',
      align: 'start',
      sortable: false,
      width: 200,
    });

    this.headers.push({
      text: 'Cliente',
      value: 'customer',
      align: 'start',
      sortable: false,
      width: 200,
    });

    this.headers.push({
      text: 'Prov.',
      value: 'installationProvince',
      align: 'start',
      sortable: false,
      width: 60,
    });

    // FIXME: Mostrare solo a chi ha il permesso di vederlo
    this.headers.push({
      text: 'Fornitura',
      value: 'supply',
      align: 'start',
      sortable: false,
      width: 150,
    });

    if (this.hasPermission('attachments.progettoElettrico.read')) {
      this.headers.push({
        text: 'Progetto',
        value: 'planStatus',
        align: 'start',
        sortable: false,
      });
    }

    if (this.hasPermission('attachments.titoloAutorizzativo.read')) {
      this.headers.push({
        text: 'Titolo autoriz.',
        value: 'titoloAutorizzativoStatus',
        align: 'start',
        sortable: false,
      });
    }

    this.headers.push({
      text: 'Documentazione MUP1 / Domanda',
      value: 'practicesJob',
      align: 'start',
      sortable: false,
      class: 'small-header-label',
    });

    if (this.hasPermission('practiceAssignment.show') || this.hasPermission('projectAssignment.show')) {
      this.headers.push({
        text: 'Incarichi',
        value: 'assignments',
        align: 'start',
        sortable: false,
        class: 'flk-sortable',
      });
    }

    if (this.hasPermission('practiceNumber.show')) {
      this.headers.push({
        text: 'Note e num. pratica',
        value: 'practiceNumber',
        align: 'start',
        sortable: false,
      });
    }

    // FIXME: Mostrare solo a chi ha il permesso di vederlo
    this.headers.push({
      text: 'Iter',
      value: 'iter',
      align: 'start',
      sortable: false,
    });

    if (this.hasPermission('mup1RequestDate.show')) {
      this.headers.push({
        text: 'Richiesta mandato rappr.',
        value: 'mup1RequestDate',
        align: 'start',
        class: 'flk-sortable small-header-label',
        sortable: false,
      });
    }

    if (this.hasPermission('practiceSendingDate.show')) {
      this.headers.push({
        text: 'Invio doc. MUP1 / Domanda',
        value: 'practiceSendingDate',
        align: 'start',
        sortable: false,
        class: 'flk-sortable small-header-label',
      });
    }

    // Conferma iter
    this.headers.push({
      text: 'Conferma iter / Preventivo TICA',
      value: 'iterConfirmationDate',
      align: 'start',
      sortable: false,
      class: 'small-header-label',
    });

    this.headers.push({
      text: 'Installazione',
      value: 'installationDate',
      align: 'start',
      sortable: false,
      class: 'flk-sortable',
    });

    this.headers.push({
      text: 'Documentazione MUP2',
      value: 'practicesMUP2',
      align: 'start',
      sortable: false,
    });

    // Documentazione fine lavori inviata all'assegnatario delle pratiche di connessione
    this.headers.push({
      text: 'Doc. fine lavori',
      value: 'docsSentToPartner',
      align: 'start',
      sortable: false,
    });

    if (this.hasPermission('rdeSendingDate.show')) {
      this.headers.push({
        text: 'Invio RDE',
        value: 'rdeSendingDate',
        align: 'start',
        sortable: false,
      });
    }

    if (this.hasPermission('endOfWorksDate.show')) {
      this.headers.push({
        text: 'Conferma RDE',
        value: 'endOfWorksDate',
        align: 'start',
        sortable: false,
        class: 'small-header-label',
      });
    }

    // FIXME: Mostrare solo a chi ha il permesso di vederlo
    this.headers.push({
      text: 'Allacciamento',
      value: 'connectionStatus',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Storico',
      value: 'cancelledConnections',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Pratica ENEA',
      value: 'eneaPracticeProgress',
      align: 'start',
      sortable: false,
    });

    if (this.hasPermission('eneaPracticeDate.show')) {
      this.headers.push({
        text: 'ENEA/GSE/Altro',
        value: 'eneaPracticeDate',
        align: 'start',
        sortable: false,
        class: 'flk-sortable small-header-label',
      });
    }

    this.headers.push({
      text: 'Dogane',
      value: 'dogane',
      align: 'start',
      sortable: false,
      width: 150,
    });

    this.headers.push({
      text: '',
      value: 'actions',
      align: 'start',
      sortable: false,
    });
  }

  async initFilters() {
    console.log(`${this.constructor.name}: initFilters()`); // eslint-disable-line no-console

    await this.$store.dispatch('initConnectionsFilters');

    // Se esistono dei filtri salvati, li imposto
    if (this.currentFilters !== null) {
      // Imposta il valore di default del filtro sullo stato delle commesse
      this.$set(
        this.filters,
        'status',
        this.currentFilters.status && Array.isArray(this.currentFilters.status)
          ? this.currentFilters.status
          : [],
      );

      // Imposta il valore di default del filtro sullo stato delle figlie
      this.$set(
        this.filters,
        'childStatus',
        this.currentFilters.childStatus && Array.isArray(this.currentFilters.childStatus)
          ? this.currentFilters.childStatus
          : [],
      );

      if (this.currentFilters.search) {
        this.$set(this.filters, 'search', this.currentFilters.search);
        this.previousSearch = this.currentFilters.search ?? '';
      }

      if (this.currentFilters.iter !== undefined) {
        this.$set(this.filters, 'iter', this.currentFilters.iter);
      }

      // Se non è stata impostata la logica per i filtri sugli assegnatari, la imposto a OR
      this.$set(this.filters, 'practiceAssigneesLogic', this.currentFilters.practiceAssigneesLogic ?? 'OR');

      // Se non è mai stata impostata la lista degli assegnatari, la imposto a vuota
      this.$set(
        this.filters,
        'practiceAssignees',
        this.currentFilters.practiceAssignees && Array.isArray(this.currentFilters.practiceAssignees)
          ? this.currentFilters.practiceAssignees
          : [],
      );

      if (this.currentFilters?.practiceAssigneesNegated !== undefined && Array.isArray(this.currentFilters.practiceAssigneesNegated)) {
        this.$set(this.filters, 'practiceAssigneesNegated', this.currentFilters.practiceAssigneesNegated);
      }

      // Se non è stato impostata la logica sullo stato delle pratiche assegnate, la imposto a vuota
      this.$set(
        this.filters,
        'practiceAssigneesStatus',
        this.currentFilters.practiceAssigneesStatus,
      );

      // Filtri project assignees
      this.$set(this.filters, 'projectAssigneesLogic', this.currentFilters.projectAssigneesLogic ?? 'OR');
      this.$set(
        this.filters,
        'projectAssignees',
        this.currentFilters.projectAssignees && Array.isArray(this.currentFilters.projectAssignees)
          ? this.currentFilters.projectAssignees
          : [],
      );
      if (this.currentFilters?.projectAssigneesNegated !== undefined && Array.isArray(this.currentFilters.projectAssigneesNegated)) {
        this.$set(this.filters, 'projectAssigneesNegated', this.currentFilters.projectAssigneesNegated);
      }
      this.$set(
        this.filters,
        'projectAssigneesStatus',
        this.currentFilters.projectAssigneesStatus,
      );

      // Filtri installer assignees
      this.$set(this.filters, 'installerAssigneesLogic', this.currentFilters.installerAssigneesLogic ?? 'OR');
      this.$set(
        this.filters,
        'installerAssignees',
        this.currentFilters.installerAssignees && Array.isArray(this.currentFilters.installerAssignees)
          ? this.currentFilters.installerAssignees
          : [],
      );
      if (this.currentFilters?.installerAssigneesNegated !== undefined && Array.isArray(this.currentFilters.installerAssigneesNegated)) {
        this.$set(this.filters, 'installerAssigneesNegated', this.currentFilters.installerAssigneesNegated);
      }
      this.$set(
        this.filters,
        'installerAssigneesStatus',
        this.currentFilters.installerAssigneesStatus,
      );

      this.$set(
        this.filters,
        'taskCm',
        this.currentFilters.taskCm && Array.isArray(this.currentFilters.taskCm)
          ? this.currentFilters.taskCm
          : [],
      );

      // Se non è stata impostata la logica per i filtri sulle categorie, la imposto a AND
      this.$set(this.filters, 'categoriesLogic', this.currentFilters.categoriesLogic ?? 'AND');

      // Se non è stata (mai) impostata la lista delle categorie, la imposto a vuota
      this.$set(
        this.filters,
        'categories',
        this.currentFilters.categories && Array.isArray(this.currentFilters.categories)
          ? this.currentFilters.categories
          : [],
      );

      if (this.currentFilters?.categoriesNegated !== undefined && Array.isArray(this.currentFilters.categoriesNegated)) {
        this.$set(this.filters, 'categoriesNegated', this.currentFilters.categoriesNegated);
      }

      // Se non è stata impostata la logica per i filtri sui tag, la imposto a AND
      this.$set(this.filters, 'tagsLogic', this.currentFilters.tagsLogic ?? 'AND');

      // Se non è stata (mai) impostata la lista dei tag, la imposto a vuota
      this.$set(
        this.filters,
        'tags',
        this.currentFilters.tags && Array.isArray(this.currentFilters.tags)
          ? this.currentFilters.tags
          : [],
      );

      if (this.currentFilters?.tagsNegated !== undefined && Array.isArray(this.currentFilters.tagsNegated)) {
        this.$set(this.filters, 'tagsNegated', this.currentFilters.tagsNegated);
      }

      // Se non è stata impostata la logica per i filtri sulle provincie, la imposto a OR
      this.$set(this.filters, 'provincesLogic', this.currentFilters.provincesLogic ?? 'OR');

      // Se non è stata (mai) impostata la lista delle province, la imposto a vuota
      this.$set(
        this.filters,
        'provinces',
        this.currentFilters.provinces && Array.isArray(this.currentFilters.provinces)
          ? this.currentFilters.provinces
          : [],
      );

      if (this.currentFilters?.provincesNegated !== undefined && Array.isArray(this.currentFilters.provincesNegated)) {
        this.$set(this.filters, 'provincesNegated', this.currentFilters.provincesNegated);
      }

      this.$set(
        this.filters,
        'egridConnectionStatus',
        this.currentFilters.egridConnectionStatus
          && Array.isArray(this.currentFilters.egridConnectionStatus)
          ? this.currentFilters.egridConnectionStatus
          : [],
      );

      this.$set(
        this.filters,
        'installationStatus',
        this.currentFilters.installationStatus
          && Array.isArray(this.currentFilters.installationStatus)
          ? this.currentFilters.installationStatus
          : [],
      );

      this.$set(
        this.filters,
        'projectStatus',
        this.currentFilters.projectStatus
          && Array.isArray(this.currentFilters.projectStatus)
          ? this.currentFilters.projectStatus
          : [],
      );

      this.$set(
        this.filters,
        'docsSentToPartner',
        normalizeDocsSentToPartner(this.currentFilters.docsSentToPartner),
      );

      if (this.currentFilters?.sortBy) {
        this.$set(
          this.filters,
          'sortBy',
          Array.isArray(this.currentFilters.sortBy)
            ? this.currentFilters.sortBy
            : [],
        );
        this.$set(
          this.options,
          'sortBy',
          Array.isArray(this.currentFilters.sortBy)
            ? this.currentFilters.sortBy
            : [],
        );
      }

      if (this.currentFilters?.sortDesc) {
        this.$set(
          this.filters,
          'sortDesc',
          Array.isArray(this.currentFilters.sortDesc)
            ? this.currentFilters.sortDesc
            : [],
        );
        this.$set(
          this.options,
          'sortDesc',
          Array.isArray(this.currentFilters.sortDesc)
            ? this.currentFilters.sortDesc
            : [],
        );
      }

      this.$set(
        this.filters,
        'dates',
        this.currentFilters.dates
          ? this.currentFilters.dates
          : {
            value: null,
            begin: null,
            end: null,
          },
      );

      // filtri sulla ricerca testuale delle colonne
      if (this.currentFilters.searchValue !== undefined) {
        this.$set(this.filters, 'searchValue', this.currentFilters.searchValue);
      }

      this.$set(
        this.filters,
        'searchItems',
        this.currentFilters.searchItems && Array.isArray(this.currentFilters.searchItems)
          ? this.currentFilters.searchItems
          : [],
      );

      if (this.currentFilters.searchLogic === 'AND' || this.currentFilters.searchLogic === 'OR') {
        this.$set(this.filters, 'searchLogic', this.currentFilters.searchLogic);
      }
      if (this.currentFilters.searchExclude !== undefined) {
        this.$set(this.filters, 'searchExclude', this.currentFilters.searchExclude ?? null);
      }
    }

    this.filtersMustBeUpdated();
  }

  // Ricarica l'elenco connessioni
  async reload() {
    console.log(`${this.constructor.name}: reload()`); // eslint-disable-line no-console

    // Elimina l'elenco connessioni attuale
    this.$store.dispatch('clearConnectionsList');

    await this.onGetConnections();

    // Avvia l'aggiornamento del contatore
    setTimeout(() => {
      this.$store.dispatch('getConnectionsCount');
    }, 2000);
  }

  operationInfo(connection: Connection): OperationInfo {
    return operationInfoFromConnection(connection);
  }

  // Verifica se i filtri sono vuoti
  get areFiltersEmpty() {
    if (this.filters?.status && Array.isArray(this.filters.status)
      && this.filters.status.length > 0) return false;
    if (this.filters?.childStatus && Array.isArray(this.filters.childStatus)
      && this.filters.childStatus.length > 0) return false;
    if (this.filters?.search && this.filters.search.trim() !== '') return false;
    if (this.filters?.iter !== undefined) return false;
    if (this.filters?.practiceAssignees && Array.isArray(this.filters.practiceAssignees)
      && this.filters.practiceAssignees.length > 0) return false;
    if (this.filters?.practiceAssigneesLogic && this.filters.practiceAssigneesLogic !== 'OR') return false;
    if (this.filters?.practiceAssigneesStatus !== null
      && this.filters?.practiceAssigneesStatus !== undefined) return false;
    if (this.filters?.projectAssignees && Array.isArray(this.filters.projectAssignees)
      && this.filters.projectAssignees.length > 0) return false;
    if (this.filters?.projectAssigneesLogic && this.filters.projectAssigneesLogic !== 'OR') return false;
    if (this.filters?.projectAssigneesStatus !== null
      && this.filters?.projectAssigneesStatus !== undefined) return false;
    if (this.filters?.installerAssignees && Array.isArray(this.filters.installerAssignees)
      && this.filters.installerAssignees.length > 0) return false;
    if (this.filters?.installerAssigneesLogic && this.filters.installerAssigneesLogic !== 'OR') return false;
    if (this.filters?.installerAssigneesStatus !== null
      && this.filters?.installerAssigneesStatus !== undefined) return false;
    if (this.filters?.taskCm && Array.isArray(this.filters.taskCm)
      && this.filters.taskCm.length > 0) return false;
    if (this.filters?.categories && Array.isArray(this.filters.categories)
      && this.filters.categories.length > 0) return false;
    if (this.filters?.categoriesLogic && this.filters.categoriesLogic !== 'AND') return false;
    if (this.filters?.tags && Array.isArray(this.filters.tags)
      && this.filters.tags.length > 0) return false;
    if (this.filters?.tagsLogic && this.filters.tagsLogic !== 'AND') return false;
    if (this.filters?.provinces && Array.isArray(this.filters.provinces)
      && this.filters.provinces.length > 0) return false;
    if (this.filters?.provincesLogic && this.filters.provincesLogic !== 'OR') return false;
    if (this.filters?.egridConnectionStatus && Array.isArray(this.filters.egridConnectionStatus)
      && this.filters.egridConnectionStatus.length > 0) return false;
    if (this.filters?.installationStatus && Array.isArray(this.filters.installationStatus)
      && this.filters.installationStatus.length > 0) return false;
    if (this.filters?.projectStatus && Array.isArray(this.filters.projectStatus)
      && this.filters.projectStatus.length > 0) return false;
    if (this.filters?.docsSentToPartner !== null
      && this.filters?.docsSentToPartner !== undefined) return false;
    if (this.filters?.dates && this.filters?.dates?.value !== null) return false;
    if (this.options?.sortBy && Array.isArray(this.options.sortBy)
      && this.options.sortBy.length > 0) return false;
    if (this.options?.sortDesc && Array.isArray(this.options.sortDesc)
      && this.options.sortDesc.length > 0) return false;

    if (this.filters?.searchItems && Array.isArray(this.filters.searchItems)
      && this.filters.searchItems.length > 0) return false;
    if (this.filters?.searchValue !== undefined) return false;

    return true;
  }

  get connectionsFilterPresets() {
    return this.$store.getters.currentConnectionsFilterPresets ?? [];
  }

  onPauseCountdown() {
    console.log(`${this.constructor.name}: onPauseCountdown()`); // eslint-disable-line no-console

    this.applyFiltersDisabled = true;
    this.applyFiltersTimeout = 0;
  }

  onRestartCountdown() {
    console.log(`${this.constructor.name}: onRestartCountdown()`); // eslint-disable-line no-console

    this.applyFiltersDisabled = false;
    this.applyFiltersTimeout = 10;
    this.applyFiltersCount += 1;
  }

  onFilter(name: string, begin: Date | null | false, end: Date | null | false) {
    console.log(`${this.constructor.name}: onFilter('${name}', %o, %o)`, begin, end); // eslint-disable-line no-console

    if (begin) {
      // Filtra per un intervallo di date
      this.$set(this.filters, 'dates', {
        value: name,
        begin,
        end: end ?? begin,
      });
    } else {
      this.$set(this.filters, 'dates', {
        value: begin === false && end === false ? name : null,
        begin,
        end,
      });
    }

    this.filtersNeedsAnUpdate();
  }

  onSearch(payload: { items: string[]; value: string | null; logic?: 'AND' | 'OR' | null; exclude?: string | null }) {
    console.log('Connections: onSearch()', payload); // eslint-disable-line no-console

    this.$set(this.filters, 'searchItems', payload.items);
    const searchValue = payload.value === null ? undefined : payload.value;
    this.$set(this.filters, 'searchValue', searchValue);
    this.$set(this.filters, 'searchLogic', payload.logic === 'AND' ? 'AND' : 'OR');
    this.$set(this.filters, 'searchExclude', payload.exclude ?? null);

    this.filtersNeedsAnUpdate();
  }

  // Se il campo di ricerca è stato modificato, va aggiornato l'elenco al termine del timer
  searchFilterNeedsAnUpdate() {
    if (this.filters?.search?.trim() === this.previousSearch?.trim()) return false;

    return this.filtersNeedsAnUpdate();
  }

  // Se il campo di ricerca è stato modificato, va aggiornato subito l'elenco
  searchFilterUpdated() {
    if (this.filters?.search?.trim() === this.previousSearch?.trim()) return false;

    return this.filtersMustBeUpdated();
  }

  onSearchFilterKeyup(event) {
    // Premendo invio i filtri vengono applicati - equivale a premere Applica
    if (event.keyCode === 13) return this.searchFilterUpdated();

    // Backspace, Delete
    if ([8, 46].includes(event.keyCode)) return this.searchFilterNeedsAnUpdate();

    if (String.fromCharCode(event.keyCode).match(/(\w|\s)/g)) {
      return this.searchFilterNeedsAnUpdate();
    }

    return false;
  }

  onOptionsChange() {
    console.log(`${this.constructor.name}: onOptionsChange() options =`, this.options); // eslint-disable-line no-console

    if (this.options?.sortBy) {
      this.$set(
        this.filters,
        'sortBy',
        Array.isArray(this.options.sortBy)
          ? this.options.sortBy
          : [],
      );
    }

    if (this.options?.sortDesc) {
      this.$set(
        this.filters,
        'sortDesc',
        Array.isArray(this.options.sortDesc)
          ? this.options.sortDesc
          : [],
      );
    }

    this.filtersNeedsAnUpdate();
  }

  onSort(name: string) {
    console.log(`${this.constructor.name}: onSort('${name}')`); // eslint-disable-line no-console

    const index = this.options.sortBy?.findIndex((n) => n === name);

    if (index !== null && index !== undefined && index > -1) {
      // È già attivo un ordinamento su questa colonna
      console.log(`${this.constructor.name}: onSort('${name}') ordinamento già attivo`); // eslint-disable-line no-console

      if (this.options.sortDesc
        && index in this.options.sortDesc
        && (this.options.sortDesc[index] === false || this.options.sortDesc[index] === 'false')) {
        // Inverte l'ordinamento
        console.log(`${this.constructor.name}: onSort('${name}') inverto l'ordinamento`); // eslint-disable-line no-console
        this.$set(this.options, 'sortDesc', [true]);
      } else {
        // Disattiva l'ordinamento
        console.log(`${this.constructor.name}: onSort('${name}') disattivo l'ordinamento`); // eslint-disable-line no-console
        this.$set(this.options, 'sortBy', []);
        this.$set(this.options, 'sortDesc', []);
      }
    } else {
      console.log(`${this.constructor.name}: onSort('${name}') nessun ordinamento attivo`); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onSort('${name}') attivo l'ordinamento`); // eslint-disable-line no-console
      this.$set(this.options, 'sortBy', [name]);
      this.$set(this.options, 'sortDesc', [false]);
    }

    this.onOptionsChange();
  }

  onResetFilters() {
    console.log(`${this.constructor.name}: onResetFilters()`); // eslint-disable-line no-console

    this.$set(this.filters, 'status', []);
    this.$set(this.filters, 'childStatus', []);
    this.$set(this.filters, 'search', '');
    this.$set(this.filters, 'iter', undefined);
    this.$set(this.filters, 'practiceAssignees', []);
    this.$set(this.filters, 'practiceAssigneesLogic', 'OR');
    this.$set(this.filters, 'practiceAssigneesNegated', []);
    this.$set(this.filters, 'practiceAssigneesStatus', null);
    this.$set(this.filters, 'projectAssignees', []);
    this.$set(this.filters, 'projectAssigneesLogic', 'OR');
    this.$set(this.filters, 'projectAssigneesNegated', []);
    this.$set(this.filters, 'projectAssigneesStatus', null);
    this.$set(this.filters, 'installerAssignees', []);
    this.$set(this.filters, 'installerAssigneesLogic', 'OR');
    this.$set(this.filters, 'installerAssigneesNegated', []);
    this.$set(this.filters, 'installerAssigneesStatus', null);
    this.$set(this.filters, 'taskCm', []);
    this.$set(this.filters, 'categories', []);
    this.$set(this.filters, 'categoriesLogic', 'AND');
    this.$set(this.filters, 'categoriesNegated', []);
    this.$set(this.filters, 'tags', []);
    this.$set(this.filters, 'tagsLogic', 'AND');
    this.$set(this.filters, 'tagsNegated', []);
    this.$set(this.filters, 'provinces', []);
    this.$set(this.filters, 'provincesLogic', 'OR');
    this.$set(this.filters, 'provincesNegated', []);
    this.$set(this.filters, 'egridConnectionStatus', []);
    this.$set(this.filters, 'installationStatus', []);
    this.$set(this.filters, 'docsSentToPartner', null);
    this.$set(this.filters, 'projectStatus', []);
    this.$set(this.filters, 'dates', {
      value: null,
      begin: null,
      end: null,
    });
    this.$set(this.filters, 'searchValue', undefined);
    this.$set(this.filters, 'searchItems', []);
    this.$set(this.filters, 'searchLogic', 'OR');
    this.$set(this.filters, 'searchExclude', null);
    this.$set(this.options, 'sortBy', []);
    this.$set(this.options, 'sortDesc', []);

    this.filtersNeedsAnUpdate();
  }

  async onSavePreset({ name, filters }: { name: string; filters: any }) {
    console.log(`${this.constructor.name}: onSavePreset()`, { name, filters }); // eslint-disable-line no-console

    try {
      await this.$store.dispatch('saveConnectionsFilterPreset', { name, filters });
      console.log(`Preset "${name}" salvato con successo`); // eslint-disable-line no-console
    } catch (error) {
      console.error('Errore nel salvataggio del preset:', error); // eslint-disable-line no-console
    }
  }

  async onLoadPreset({ name, filters }: { name: string; filters: any }) {
    console.log(`${this.constructor.name}: onLoadPreset()`, { name, filters }); // eslint-disable-line no-console

    try {
      // Applica i filtri del preset
      Object.keys(filters).forEach((key: string) => {
        this.$set(this.filters, key, filters[key]);
      });

      // Normalizza docsSentToPartner per preset legacy (boolean[] -> string tri-state)
      this.$set(
        this.filters,
        'docsSentToPartner',
        normalizeDocsSentToPartner(this.filters.docsSentToPartner),
      );

      // Applica i filtri in modo asincrono per non bloccare l'UI
      await this.$nextTick();
      this.filtersMustBeUpdated();
      console.log(`Preset "${name}" caricato con successo`); // eslint-disable-line no-console
    } catch (error) {
      console.error('Errore nel caricamento del preset:', error); // eslint-disable-line no-console
    }
  }

  async onDeletePreset({ name }: { name: string }) {
    try {
      await this.$store.dispatch('deleteConnectionsFilterPreset', name);
      console.log(`Preset "${name}" eliminato con successo`); // eslint-disable-line no-console
    } catch (error) {
      console.error('Errore nell\'eliminazione del preset:', error); // eslint-disable-line no-console
    }
  }

  // I filtri sono stati modificati ed è richiesto un aggiornamento
  // al termine del timer
  filtersNeedsAnUpdate() {
    console.log(`${this.constructor.name}: filtersNeedsAnUpdate()`); // eslint-disable-line no-console

    this.applyFiltersDisabled = false;
    this.applyFiltersTimeout = 10;
    this.applyFiltersCount += 1;
  }

  // I filtri sono stati modificati e va aggiornato subito l'elenco
  filtersMustBeUpdated() {
    console.log(`${this.constructor.name}: filtersMustBeUpdated()`); // eslint-disable-line no-console

    // Ferma il timer
    this.applyFiltersDisabled = true;
    this.applyFiltersTimeout = 0;

    // Memorizza i filtri
    this.$store.dispatch('updateConnectionsFilters', this.filters);

    // Richiede l'aggiornamento dell'elenco
    this.reload();
  }

  onAssignmentFilterUpdate(typeId: string, data: { assignees: (number | null)[]; logic: LogicType; negated: (number | string)[] }) {
    console.log(`${this.constructor.name}: onAssignmentFilterUpdate() typeId =`, typeId); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: onAssignmentFilterUpdate() data =`, data); // eslint-disable-line no-console

    if (data.assignees) {
      this.$set(
        this.filters,
        `${typeId}Assignees`,
        Array.isArray(data.assignees) ? data.assignees : [],
      );
    }

    if (data.logic) {
      this.$set(
        this.filters,
        `${typeId}AssigneesLogic`,
        data.logic || 'OR',
      );
    }

    this.$set(this.filters, `${typeId}AssigneesNegated`, data.negated ?? []);
  }

  onAssignmentStatusChange(typeId: string, status: PracticeAssigneesStatus | null) {
    console.log(`${this.constructor.name}: onAssignmentStatusChange() typeId =`, typeId); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: onAssignmentStatusChange() status =`, status); // eslint-disable-line no-console

    this.$set(this.filters, `${typeId}AssigneesStatus`, status);
  }

  onCategoryFilterUpdate(items: number[], logic: LogicType, negatedIds?: (number | string)[]) {
    console.log(`${this.constructor.name}: onCategoryFilterUpdate() items =`, items); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: onCategoryFilterUpdate() logic =`, logic); // eslint-disable-line no-console

    if (items) {
      this.$set(
        this.filters,
        'categories',
        Array.isArray(items)
          ? items
          : [],
      );
    }

    if (logic) {
      this.$set(
        this.filters,
        'categoriesLogic',
        logic || 'AND',
      );
    }

    this.$set(this.filters, 'categoriesNegated', negatedIds ?? []);

    this.filtersNeedsAnUpdate();
  }

  onTagFilterUpdate(items: number[], logic: LogicType, negatedIds?: (number | string)[]) {
    console.log(`${this.constructor.name}: onTagFilterUpdate() items =`, items); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: onTagFilterUpdate() logic =`, logic); // eslint-disable-line no-console

    if (items) {
      this.$set(
        this.filters,
        'tags',
        Array.isArray(items)
          ? items
          : [],
      );
    }

    if (logic) {
      this.$set(
        this.filters,
        'tagsLogic',
        logic || 'AND',
      );
    }

    this.$set(this.filters, 'tagsNegated', negatedIds ?? []);

    this.filtersNeedsAnUpdate();
  }

  onProvinceFilterUpdate(items: string[], logic: LogicType, negatedIds?: (number | string)[]) {
    console.log(`${this.constructor.name}: onProvinceFilterUpdate()`); // eslint-disable-line no-console

    if (items) {
      this.$set(
        this.filters,
        'provinces',
        Array.isArray(items)
          ? items
          : [],
      );
    }

    if (logic) {
      this.$set(
        this.filters,
        'provincesLogic',
        logic,
      );
    }

    this.$set(this.filters, 'provincesNegated', negatedIds ?? []);

    this.filtersNeedsAnUpdate();
  }

  async onGetConnections() {
    console.log(`${this.constructor.name}: onGetConnections()`); // eslint-disable-line no-console

    let doItAgain = true;

    while (doItAgain) {
      console.log(`${this.constructor.name}: onGetConnections() richiamo getConnections`); // eslint-disable-line no-console

      // eslint-disable-next-line no-await-in-loop
      this.more = await this.$store.dispatch('getConnections');

      // Se non ci sono altri risultati da recuperare, si ferma subito
      if (!this.more) break;

      const scrollHeight = this.tableElement?.scrollHeight ?? 0;
      const clientHeight = this.tableElement?.clientHeight ?? 0;
      const scrollTop = this.tableElement?.scrollTop ?? 0;
      const distance = scrollHeight - clientHeight - scrollTop;

      console.log(`${this.constructor.name}: onGetConnections() scrollHeight = ${scrollHeight}`); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onGetConnections() clientHeight = ${clientHeight}`); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onGetConnections() scrollTop = ${scrollTop}`); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onGetConnections() distance = ${distance}`); // eslint-disable-line no-console

      doItAgain = distance === 0 && scrollHeight === clientHeight;
    }

    return Promise.resolve();
  }

  async onScroll() {
    // Se sta recuperando altri risultati, non fa nulla.
    if (this.updating) return;

    // Se non ci sono altri risultati da recuperare, non fa nulla.
    if (!this.more) return;

    // Calcola la distanza dalla fine della tabella coi risultati
    const scrollHeight = this.tableElement?.scrollHeight ?? 0;
    const clientHeight = this.tableElement?.clientHeight ?? 0;
    const scrollTop = this.tableElement?.scrollTop ?? 0;
    const distance = scrollHeight - clientHeight - scrollTop;

    if (distance < 200) {
      console.log(`${this.constructor.name}: onScroll() richiamo getConnections`); // eslint-disable-line no-console
      this.more = await this.$store.dispatch('getConnections');
    }
  }

  onHorizontalScroll() {
    if (!this.tableElement) {
      return;
    }

    // tableElement è già il .v-data-table__wrapper
    const wrapper = this.tableElement as HTMLElement;
    const scrollLeft = wrapper.scrollLeft ?? 0;
    const hasScroll = scrollLeft > 0;

    if (hasScroll !== this.hasHorizontalScroll) {
      this.$set(this, 'hasHorizontalScroll', hasScroll);
    }
  }

  async onExport(exportType: string) {
    console.log(`${this.constructor.name}: onExport()`); // eslint-disable-line no-console

    await this.$store.dispatch('exportConnections', exportType);
  }

  onHeaderResize() {
    if (this.contentElement) this.contentElement.style.top = this.headerElement ? `${this.headerElement.offsetHeight}px` : '125px';
  }

  async onCancelConnection(connectionId, confirm = false, reason = null) {
    console.log(`${this.constructor.name}: onCancelConnection() connectionId = ${connectionId}`); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: onCancelConnection() confirm = ${confirm}`); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: onCancelConnection() reason = ${reason}`); // eslint-disable-line no-console

    if (!confirm) {
      this.loadingConnection = connectionId;

      // Seleziona la Connection prima di aprire il dialog
      await this.$store.dispatch('selectConnection', { id: connectionId });

      this.loadingConnection = null;
      this.cancelConnectionDialog = true;
    } else {
      // In questo caso archivo la connessione
      console.log(`${this.constructor.name}: onCancelConnection() connectionId = ${connectionId} - CONFERMA ARCHIVIAZIONE`); // eslint-disable-line no-console

      this.loadingConnection = this.selectedConnection?.id ?? null;

      // Archivia la connessione selezionata
      await this.$store.dispatch('cancelConnection', {
        id: this.selectedConnection?.id ?? null,
        reason,
      });

      this.loadingConnection = null;
    }
  }

  // Deseleziona la Connection
  unselectConnection() {
    this.$store.dispatch('unselectConnection');
  }

  cycleDocsSentToPartner(): void {
    const current = this.filters.docsSentToPartner;
    let next: DocsSentToPartnerFilter | null;
    if (current === null || current === undefined) {
      next = 'sent';
    } else if (current === 'sent') {
      next = 'not-sent';
    } else {
      next = null;
    }
    this.$set(this.filters, 'docsSentToPartner', next);
    this.filtersNeedsAnUpdate();
  }

  get docsSentToPartnerActive(): boolean {
    return this.filters.docsSentToPartner === 'sent'
      || this.filters.docsSentToPartner === 'not-sent';
  }

  get docsSentToPartnerIcon(): string {
    return this.filters.docsSentToPartner === 'sent'
      ? 'mdi-folder-table'
      : 'mdi-folder-table-outline';
  }

  get docsSentToPartnerIconColor(): string {
    if (this.filters.docsSentToPartner === 'sent') return 'success';
    if (this.filters.docsSentToPartner === 'not-sent') return 'orange';
    return '';
  }

  get docsSentToPartnerClass(): string {
    if (this.filters.docsSentToPartner === 'sent') return 'success--text';
    if (this.filters.docsSentToPartner === 'not-sent') return 'orange--text';
    return '';
  }

  get docsSentToPartnerTooltip(): string {
    if (this.filters.docsSentToPartner === 'sent') return 'Filtra: documentazione fine lavori inviata';
    if (this.filters.docsSentToPartner === 'not-sent') return 'Filtra: documentazione fine lavori NON inviata';
    return 'Filtra per invio documentazione fine lavori';
  }
}
